import useWorkflowDraft from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Providers/WorkflowDraftProvider/useWorkflowDraft';
import { css } from '@emotion/react';
import { ArrowDown, ArrowUp } from 'lucide-react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';

const actionsStyle = css`
	display: flex;
	align-items: center;
	gap: 0.375rem;
`;

type Props = {
	readonly stageIndex: number;
};

/** Leaf actions of a stage: move it up or down, or delete it with its documents. Nothing is confirmed — the draft is only saved on request. */
const StageCardActions: React.FC<Props> = ({ stageIndex }) => {
	const { draft, setDraft } = useWorkflowDraft();
	const stageNumber = stageIndex + 1;

	const handleMoveUpClick = React.useCallback(() => {
		setDraft((current) => current.moveStage(stageIndex, -1));
	}, [setDraft, stageIndex]);

	const handleMoveDownClick = React.useCallback(() => {
		setDraft((current) => current.moveStage(stageIndex, 1));
	}, [setDraft, stageIndex]);

	const handleDeleteClick = React.useCallback(() => {
		setDraft((current) => current.removeStage(stageIndex));
	}, [setDraft, stageIndex]);

	return (
		<div css={actionsStyle}>
			<Button
				type="button"
				size="sm"
				severity="secondary"
				rounded
				icon={<ArrowUp size={16} />}
				aria-label={`Monter l’étape ${stageNumber}`}
				disabled={stageIndex === 0}
				onClick={handleMoveUpClick}
			/>
			<Button
				type="button"
				size="sm"
				severity="secondary"
				rounded
				icon={<ArrowDown size={16} />}
				aria-label={`Descendre l’étape ${stageNumber}`}
				disabled={stageIndex === draft.stages.length - 1}
				onClick={handleMoveDownClick}
			/>
			<Button
				type="button"
				size="sm"
				severity="danger"
				outlined
				label="Supprimer l’étape"
				onClick={handleDeleteClick}
			/>
		</div>
	);
};

export default StageCardActions;
